import type { ReactNode } from "react";

export function Panel({ title, actions, children, tone, testId }: {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
  tone?: "default" | "warn" | "error";
  /**
   * An optional stable hook for a real browser test.
   *
   * Present because a test that addresses a panel by its heading cannot survive a
   * stylesheet applying `text-transform`, and silently reading the wrong panel
   * produces a green run that proved nothing. Presentation only — it carries no
   * meaning and nothing reads it outside a test.
   */
  testId?: string;
}): JSX.Element {
  return (
    <section className={`panel panel-${tone ?? "default"}`} data-stage={testId}>
      <header className="panel-head">
        <h2>{title}</h2>
        {actions ? <div className="panel-actions">{actions}</div> : null}
      </header>
      <div className="panel-body">{children}</div>
    </section>
  );
}

export function Empty({ children }: { children: ReactNode }): JSX.Element {
  return <p className="empty">{children}</p>;
}
